import React, { Fragment } from "react";
import blackBackground from "../../assets/pictures/old-black-background.jpg";
import { StateContext } from "../../containers/sidebarContext";
import CoverBoxes from "../CoverBoxes";
import { useTranslation } from "react-i18next";
import DrinkContains from "../DrinkContains/DrinkContains";

const Caffee = () => {
  const state = React.useContext(StateContext);
  const { isSidebarOpen } = state;
  const { t } = useTranslation();

  const hotDrinks = [
    { id: 1, contain: 7, title: "KAFFE", price: "2.50" },
    { id: 2, contain: 7, title: "ESPRESSO", price: "2.50" },
    { id: 3, contain: 7, title: "ESPRESSO MACCHIATO", price: "2.50" },
    { id: 4, contain: 7, title: "MILCH KAFFE", price: "3.00" },
    { id: 5, contain: 7, title: "CAPPUCCIONO", price: "3.00" },
    { id: 6, contain: 7, title: "LATTE MACCHIATO", price: "3.00" },
    { id: 7, contain: 7, title: "DOPPELTE ESPRESSO", price: "3.00" },
  ];

  const instantDrinks = [
    { id: 1, title: "NESCAFE VANILIA", price: "3.00" },
    { id: 2, title: "NESCAFE CHOCOLAD", price: "3.00" },
    { id: 3, title: "NESCAFE 3u1", price: "3.00" },
  ];

  const tea = [{ id: 1, title: "Tee", price: "2.50" }];

  return (
    <Fragment>
      {isSidebarOpen && (
        <>
          <div
            style={{
              backgroundImage: `url(${blackBackground})`,
              backgroundSize: "cover",
            }}
            className="content caffee__box"
          >
            <div className="table__header">
              {" "}
              <h2>{t("caffee:hot_drinks")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {hotDrinks.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <sup>{item.contain}</sup>
                      <span>{item.title}</span>
                    </td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table__header">
              {" "}
              <h2>{t("caffee:instant_drinks")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {instantDrinks.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table__header">
              {" "}
              <h2>{t("caffee:tee")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {tea.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <DrinkContains />
          </div>
          <CoverBoxes />
        </>
      )}
    </Fragment>
  );
};

export default Caffee;
